module.exports = __webpack_public_path__ + "img/aboutUs_img7.fb4d1fec.svg";